import type BaseEntity from "./base-entity";

// Represents definition of KPI
export class KpiDefinition implements BaseEntity {
  id: string;
  name: string;
  description: string;
  whatIsBetter: string; // enum?
  unit: string; // enum?
  calculationPhrase: string;
  type: string; // enum?
  requiresCurrencyConversion: boolean;
  sourceInputValue: string; // not sure if needed
  stage: number;
  dynamicKpiParentName: string;
  dependsOnTechnology: boolean;

  constructor(
    id: string,
    name: string,
    description: string,
    whatIsBetter: string,
    unit: string,
    calculationPhrase: string,
    type: string,
    requiresCurrencyConversion: boolean,
    sourceInputValue: string,
    stage?: number,
    dynamicKpiParentName?: string,
    dependsOnTechnology?: boolean
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.whatIsBetter = whatIsBetter;
    this.unit = unit;
    this.calculationPhrase = calculationPhrase;
    this.type = type;
    this.requiresCurrencyConversion = requiresCurrencyConversion;
    this.sourceInputValue = sourceInputValue;
    this.stage = stage || 0;
    this.dynamicKpiParentName = dynamicKpiParentName || "";
    this.dependsOnTechnology = dependsOnTechnology || false;
  }

  static getScoringDescription(whatIsBetter: string): string {
    return whatIsBetter === "low" ? "Lower is better" : "Higher is better";
  }
}

// Using KPI Category you can build KPI tree structure
export interface KpiCategory extends BaseEntity {
  name: string;
  subCategories: KpiCategory[];
  kpiDefinitions: KpiDefinition[];
  dynamicKpiCategories: DynamicKpiCategory[];
  technology?: string | null;
  hidden?: boolean;
}

export interface DynamicKpiCategory extends BaseEntity {
  questionnaireId: string;
  sectionId: string;
}

export interface KpiForDynamicQuestionnaire {
  questionnaireId: string;
  categories: KpiCategory[];
}

// Document with entire KPI structure
export interface KpiStructure extends BaseEntity {
  categories: KpiCategory[];
  dynamicKpis: KpiForDynamicQuestionnaire[];
  lastUpdated: Date;
  updatedBy: string;
}

export interface KpiDependencyMap {
  [dataPointId: string]: Set<string>;
}

export interface DatapointDependencyMap {
  [kpiId: string]: Set<string>;
}
